export default __webpack_public_path__ + "static/media/Foto17.9a4c8754.png";